import { Nullable } from '@gv/triage-components';

export enum CasesExportStatus {
  Error = 'error',
  Ready = 'ready',
  Initial = 'initial',
  Processing = 'processing',
  FileCreated = 'fileCreated',
  DataPrepared = 'dataPrepared',
}

export interface CasesExportFileData {
  buffer: string;
  fileName: string;
  fileSize?: number;
}

export interface CasesExportState {
  status: CasesExportStatus;
  formValues: Nullable<Record<string, any>>;
  file: Nullable<string | CasesExportFileData>;
}
